import React from 'react';

const LoadingSpinner = () => {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <div className="flex flex-col items-center space-y-4">
        {/* Spinner */}
        <div className="relative">
          <div className="w-12 h-12 border-4 border-gray-200 border-t-sky-500 rounded-full animate-spin"></div>
        </div>
        
        {/* Loading text */}
        <div className="text-gray-600 text-sm font-medium">
          Loading...
        </div>
      </div>
    </div>
  );
};

export default LoadingSpinner;